import * as React from 'react';
import EditorLayout from 'components/EditorLayout';

export default function FlowEditor(): React.ReactElement {
  return <EditorLayout />;
}
